import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CaixaGerenciarListarComponent } from './caixa-gerenciar-listar.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: CaixaGerenciarListarComponent}
  ])],
  exports: [RouterModule]
})
export class CaixaGerenciarListarRoutingModule { }
